import Vue from 'vue';
import Vuex from 'vuex';
import uploadAdapter from './uploadAdapter';

import sessions from './modules/Sessions';
import photos from './modules/Photos';
import user from './modules/User';
import chat from './modules/Chat';
import upload from './modules/Upload';
import priceLists from './modules/PriceLists';
import welcomeMessageSets from './modules/WelcomeMessageSets';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        sessions,
        photos,
        user,
        chat,
        upload,
        priceLists,
        welcomeMessageSets,
    },
});
uploadAdapter.init(store);

export default store;
